<template>
  <div>
    <el-row type="flex" justify="space-between">
      <el-col :span="12">
        <w-trap-list-table ref="trapListTable" :active-tab="activeTab" @show-trap-detail="showTrapDetail" />
      </el-col>
      <el-col :span="12">
        <w-trap-information :selected-row="selectedRow" @update-trap-inform="updateTrapInform" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import WTrapListTable from './components/TrapListTable';
import WTrapInformation from './components/TrapInformation';

export default {
  name: 'WTrapCollectSetting',
  components: {
    WTrapListTable,
    WTrapInformation,
  },
  props: {
    activeTab: String,
  },
  data() {
    return {
      selectedRow: null,
    };
  },
  methods: {
    showTrapDetail(row) {
      this.selectedRow = row;
    },
    updateTrapInform() {
      this.$refs.trapListTable.loadData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/SnmpTrap/TrapCollectSetting.vue